//import Accordion from "@bsw/nightingale";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from "react-router-dom";
import { Accordion, NavigationHead, NavigationItem, CircleButton, CollapsedNav } from "../../index";
import { isEqual } from 'lodash';
import './navigation.scss';

export const Navigation = withRouter(({
    className,
    menuItems,
    onNavHeadClick = () => { },
    onNavItemClick = () => { },
    showArrow = true,
    toggleMainMenu = () => { },
    updateActiveNavTriggers,
    collapsed,
    toggleMenuCollapsed,
    showCollapsedButton = true
}) => {

    const [activeNavHead, setActiveNavHead] = useState(""); // Indicates if nav head accordion is open
    const [activeNavItem, setActiveNavItem] = useState(""); // Indicates if nav item sub/sliding menu is open
    const [navigationItems, setNavigationItems] = useState([]);
    const [navigationLoaded, setNavigationLoaded] = useState(false);

    const pathname = window.location.pathname.toLowerCase();
    const isDashboard = (pathname === "/" || pathname === "");

    useEffect(() => {
        if (menuItems && menuItems.length > 0) {
            getNavigationItems();
        }
    }, [menuItems]);

    useEffect(() => {
        if (isDashboard) {
            setActiveNavHead("");
            setActiveNavItem("");
        } else {
            getActiveNav();
        }
    }, [pathname]);

    useEffect(() => {
        if (navigationLoaded) {
            setNavigationLoaded(false);
        }
    }, [updateActiveNavTriggers]);

    useEffect(() => {
        if (navigationLoaded) {
            getActiveNav();
        }
    }, [navigationLoaded]);

    const getNavigationItems = () => {
        let navGroup = [];

        menuItems.map((menuItem) => {
            if (menuItem.show) {

                let navItemsToShow = [];
                menuItem?.navItems.map((navItem) => {
                    if (navItem.show) {
                        let subItems = null;
                        let subItemNav = [];
                        if (navItem.subMenuItems && navItem.subMenuItems !== null) {
                            if (navItem.subMenuItems.menuItems && navItem.subMenuItems.menuItems !== null) {
                                navItem.subMenuItems.menuItems.map((subMenuItem) => {
                                    if (subMenuItem.show) {
                                        subItemNav.push(subMenuItem);
                                    }
                                });
                            }

                            subItems = {
                                menuLabel: navItem.subMenuItems.menuLabel,
                                menuItems: subItemNav
                            };
                        }

                        navItemsToShow.push({
                            label: navItem.label,
                            url: navItem.url,
                            target: navItem.target ? navItem.target : null,
                            altUrls: navItem.altUrls ? navItem.altUrls : null,
                            disabled: navItem.disabled,
                            subMenuItems: subItems
                        });
                    }

                });

                navGroup.push({
                    disabled: menuItem.disabled,
                    navHead: menuItem.navHead,
                    navItems: navItemsToShow
                });
            }
        })

        if (!isEqual(navGroup, navigationItems)) {
            setNavigationItems(navGroup);
        }

        if (!navigationLoaded) {
            setNavigationLoaded(true);
        }
    }

    const isSelectedLink = (navLink, altUrls) => {
        const navLinkUrl = navLink && navLink.toLowerCase();
        let isSelected = navLinkUrl === pathname;

        if (!isSelected && (altUrls && altUrls.length > 0)) {
            let navLinkArray = pathname.split("/");

            isSelected = altUrls.indexOf('/' + navLinkArray[1]) !== -1;
        }

        return isSelected;
    }

    const isActiveSubMenu = (navHead, navIndex) => {

        return (activeNavHead === navHead) && (activeNavItem === navIndex) ? true : false;
    }

    const getRenderedItemsContent = () => {
        let items = [];

        navigationItems.map((menuItem, index) => {
            let isNavDisabled = menuItem?.disabled;
            let isNavHeadSelected = isSelectedLink(menuItem?.navHead?.url);
            let headerElem = menuItem?.navHead?.url
                ? <Link
                    to={{ pathname: menuItem?.navHead?.url }}
                    target={menuItem?.navHead?.target ? menuItem?.navHead?.target : null}
                    className={`${isNavHeadSelected ? 'selected' : ''} ${isNavDisabled ? 'disabled' : ''}`}></Link >
                : undefined;

            items.push({
                disabled: isNavDisabled,
                headerAs: headerElem,
                heading: <NavigationHead
                    active={activeNavHead === `${index}`}
                    className={menuItem?.navHead?.className}
                    disabled={isNavDisabled}
                    icon={menuItem?.navHead?.icon}
                    label={menuItem?.navHead?.label}
                    selected={isNavHeadSelected}
                />,
                content: (menuItem?.navItems.length > 0) &&
                    <NavigationItem
                        navItems={menuItem?.navItems}
                        onItemClick={(e, itemIndex, itemLabel) => { onItemClick(e, itemIndex, itemLabel) }}
                        isSelectedLink={(navLink, altUrls) => isSelectedLink(navLink, altUrls)}
                        isActiveSubMenu={(itemIndex) => isActiveSubMenu(`${index}`, itemIndex)}
                        toggleMainMenu={toggleMainMenu}
                    />

            });
        });

        return items;
    }

    const getActiveNav = () => {
        for (let index in navigationItems) {
            if (activeNavExist(navigationItems[index].navHead)) {
                setActiveNavHead(`${index}`);
                setActiveNavItem('');
                break;
            } else {
                getActiveMenuItemIndex(navigationItems[index].navItems, index);
            }
        }
    }

    const getActiveMenuItemIndex = (navItems, navHeadIndex) => {
        for (let navItemIndex in navItems) {

            if (activeNavExist(navItems[navItemIndex])) {
                setActiveNavHead(`${navHeadIndex}`);
                setActiveNavItem(``);
                break;
            } else {
                if (navItems[navItemIndex].subMenuItems !== null &&
                    navItems[navItemIndex].subMenuItems.menuItems &&
                    navItems[navItemIndex].subMenuItems.menuItems.length > 0
                ) {
                    let navSubItems = [];

                    navItems[navItemIndex].subMenuItems?.menuItems.map((navItem) => {
                        navItem.show &&
                            navSubItems.push(navItem);
                    });

                    for (let index in navSubItems) {
                        if (activeNavExist(navSubItems[index])) {
                            setActiveNavHead(`${navHeadIndex}`);
                            setActiveNavItem(`${navItemIndex}`);
                            break;
                        }
                    }
                }
            }
        }
    }

    const activeNavExist = (nav) => {
        const navUrl = nav?.url;
        let isActiveNav = false;

        if (navUrl) {
            isActiveNav = (navUrl.toLowerCase() === pathname);
        }

        if (!isActiveNav && (nav.altUrls && nav.altUrls.length > 0)) {
            let navLinkArray = pathname.split("/");
            //isActiveNav = nav.altUrls.indexOf(pathname) !== -1;
            isActiveNav = nav.altUrls.indexOf('/' + navLinkArray[1]) !== -1;

        }

        return isActiveNav;
    }

    const onHeadClick = (e, index) => {
        if (activeNavHead !== `${index}`) {
            setActiveNavHead(`${index}`);
        } else {
            setActiveNavHead(''); //Toggles nav head accordion close
        }

        let navLabel = e?.target?.innerText || e?.currentTarget?.innerText;
        navLabel = navLabel ? navLabel.trim() : "";

        if (e?.currentTarget?.nodeName?.toLowerCase() === 'a') {
            toggleMainMenu();
        }

        onNavHeadClick(e, navLabel);
    };

    const onItemClick = (e, index, label) => {
        if (activeNavItem !== `${index}`) {
            setActiveNavItem(`${index}`)
        }

        onNavItemClick(e, label);
    };

    const accordionNavClasses = [
        `bsw-navigation`,
        `${collapsed ? 'bsw-navigation--collapsed' : ''}`,
        `${className ? className : ''}`,
    ].join(' ');

    const renderedItems = getRenderedItemsContent();

    const handleNavMenuState = (e, index) => {
        toggleMenuCollapsed();
        if (index) {
            onHeadClick(e, index);
        }
    }

    return <nav className={accordionNavClasses}>
        {!collapsed
            ? <Accordion
                openIndex={activeNavHead}
                accordionItems={renderedItems}
                showArrow={showArrow}
                toggle={(e, itemIndex) => onHeadClick(e, itemIndex)}
                borderStyle="none"
                padding="none"
            />
            : <CollapsedNav
                activeNavHead={activeNavHead}
                menuItems={navigationItems}
                onHeadClick={handleNavMenuState}
            />
        }
        {showCollapsedButton &&
            <div className="bsw-navigation__collapse-btn">
                <CircleButton
                    icon={collapsed ? "chevron-right" : "chevron-left"}
                    onClick={handleNavMenuState}
                    aria-label={collapsed ? "Expand menu" : "Collapse menu"}
                />
            </div>
        }
    </nav>;
});
